(() => {
/**
 * Key findings are tabs on desktop and accordion on mobile
 */ function $0ea80497a8f72090$var$initKeyFindings() {
    const keyFindings = document.querySelector('#key-findings');
    if (keyFindings) // listen for clicks
    keyFindings.addEventListener('click', function(e) {
        // check if the clicked element is a key-findings-grid__item-accordion-button
        if (e.target.classList.contains('key-findings-grid__accordion-button')) {
            const button = e.target;
            const controls = button.getAttribute('data-controls');
            const item = document.querySelector(`#${controls}`);
            const expanded = button.getAttribute('data-expanded') === 'true' || false;
            button.setAttribute('data-expanded', !expanded);
            item.setAttribute('data-expanded', !expanded);
        }
        if (e.target.classList.contains('key-findings-grid__tab-button')) {
            const button = e.target;
            const controls = button.getAttribute('data-controls');
            const controlsImage = button.getAttribute('data-controls-image');
            const item = document.querySelector(`#${controls}`);
            const image = document.querySelector(`#${controlsImage}`);
            const expanded = button.getAttribute('data-featured') === 'true' || false;
            // set all tab buttons to false
            const buttons = document.querySelectorAll('.key-findings-grid__tab-button');
            buttons.forEach((btn)=>{
                btn.setAttribute('data-featured', false);
            });
            const items = document.querySelectorAll('.key-findings-grid__item');
            items.forEach((itm)=>{
                itm.setAttribute('data-featured', false);
            });
            const images = document.querySelectorAll('.key-findings-grid__item-image');
            images.forEach((img)=>{
                img.setAttribute('data-featured', false);
            });
            button.setAttribute('data-featured', !expanded);
            item.setAttribute('data-featured', !expanded);
            image.setAttribute('data-featured', !expanded);
        }
    });
}
document.addEventListener('DOMContentLoaded', function() {
    // Initialize key findings
    console.log('init key findings');
    $0ea80497a8f72090$var$initKeyFindings();
});

})();
//# sourceMappingURL=landing-page.js.map
